import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiReportWidgetDetailsBaseDirective } from '../../shared/report-widget-details-base.directive';
import {
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportDateRange,
    IChecklist2ReportHistoryComplianceData,
    IChecklist2ReportHistorySummaryDetailsData,
    IChecklistHistoryDateRangeChangeEvent,
} from '../../shared/fi-checklist2-report';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { IChecklistStatusProgressData } from '@fi-shared/checklist/checklist-v2';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { BehaviorSubject } from 'rxjs';
import { IPeriodDateRange } from '@fi-shared/fi-time-range-menu/fi-time-range-menu';
import { FiChecklist2ReportTimePeriodType } from '../../enums/fi-checklist2-report-time-period-type';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-checklist2-history-report',
    templateUrl: './checklist-history-report.component.html',
    styleUrls: ['./checklist-history-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-history-report' },
    standalone: false,
})
export class FiChecklistHistoryReportComponent extends FiReportWidgetDetailsBaseDirective implements OnInit {
    @Input() historyLoading: boolean;
    @Output() checklistHistoryDateRangeChange = new EventEmitter<IChecklistHistoryDateRangeChangeEvent>();
    @Output() onShowChecklistHistoryDetails = new EventEmitter<IChecklist2ReportHistorySummaryDetailsData>();
    checklistHistorySummary: IChecklist2ReportChecklistSummary[] = [];

    protected checklistHistoryDateRange: IChecklist2ReportDateRange;
    protected FiChecklist2ReportTimePeriodType = FiChecklist2ReportTimePeriodType;
    protected checklistWidgetHistoryOptions: INameIdObj[];
    ngOnInit(): void {
        this.checklistHistoryDateRange = this.fiChecklist2ReportDataService.getDateRange(this.reportParam.Id);
        this.setNonComplianceData();
        setTimeout(() => {
            this.setChecklistHistoryDateRange(this.checklistHistoryDateRange);
        });
        this.checklistWidgetHistoryOptions = this.fiChecklist2ReportHelperService.getChecklistReportHistoryOptions();
    }

    getStatusProgressData(): IChecklistStatusProgressData {
        return this.fiChecklist2ReportHelperService.getStatusProgressDataFromSummary(this.checklistHistorySummary);
    }

    nonComplianceData$ = new BehaviorSubject<IChecklist2ReportHistoryComplianceData>(undefined);
    private setNonComplianceData() {
        this.nonComplianceData$.next(
            this.fiChecklist2ReportHelperService.getNonComplianceDataFromSummary(this.checklistHistorySummary),
        );
    }
    isNonComplianceChartVisible(): boolean {
        return (
            this.nonComplianceData$.value.nonComplianceUnitsCount + this.nonComplianceData$.value.complianceUnitsCount >
            0
        );
    }

    setChecklistHistoryDateRange(newDateRange: IChecklist2ReportDateRange) {
        this.checklistHistoryDateRangeChange.emit({
            reportParameterId: this.reportParam.Id,
            dateRange: newDateRange,
        });
    }

    showChecklistHistoryDetails(checklistHistoryDetails: IChecklist2ReportHistorySummaryDetailsData) {
        this.onShowChecklistHistoryDetails.emit(checklistHistoryDetails);
    }

    setChecklistHistorySummary(newChecklistHistorySummary: IChecklist2ReportChecklistSummary[]) {
        this.checklistHistorySummary = [...newChecklistHistorySummary];
        this.setNonComplianceData();
    }

    protected readonly FiChecklist2ReportType = FiChecklist2ReportType;
    protected readonly FiInfoIconMode = FiInfoIconMode;
}
